<template>
  <div
    class="w-full h-100px text-center bg-hex-$portalPrimaryColor flex items-center justify-center"
  >
    <div class="h-48px text-hex-fff">
      <div>建议您使用1920×1080分辨率、Microsoft Explorer10.0浏览器以获得本站的最佳浏览效果</div>
      <div>{{ statement }}</div>
    </div>
  </div>
</template>

<script>
const { config } = Wiz.globalSettings.dynamicModules.modules['portal-homepage-nanhai']

export default {
  data() {
    return {
      statement: config.statement,
    }
  },
}
</script>

<style></style>
